import ApiService from '@/common/api/api.service'

let apiBasePath = 'NotaFiscal'

const ContabilService = {
  async postPreviaDesdeRascunho(draft) {
    const { data } = await ApiService.post(`${apiBasePath}/contabil/previa`, draft)
    return data
  },
  
  async postLancamentos(notaId, payload) {
    const { data } = await ApiService.post(`${apiBasePath}/${notaId}/contabil`, payload)
    return data
  }
}

export default ContabilService
